import 'react-day-picker/style.css';
import '~/themes/calendar.scss';

import { type ComponentProps } from 'react';
import { DayPicker } from 'react-day-picker';
import { HeadRow } from '~/components/Request/multiday/components/Rows/DateRow/HeadRow';
import { MonthNavigation } from '~/components/ShiftRequestRedesign/SelectDates/MonthNavigation';

export type ICalendarPickerProps = ComponentProps<typeof DayPicker> & {
  /** Applies error background and border treatment per Figma */
  hasError?: boolean;
};

export const CalendarPicker = ({ hasError, components, ...props }: ICalendarPickerProps) => (
  <div
    data-testid="calendar-picker"
    style={
      hasError
        ? {
            backgroundColor: '#FEF2F2',
            border: '1.5px solid #ef4444',
            borderRadius: 8,
            padding: '0 12px',
          }
        : undefined
    }
  >
    <DayPicker
      components={{
        MonthCaption: MonthNavigation,
        Weekdays: HeadRow,
        ...components,
      }}
      {...props}
    />
  </div>
);
